<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Noty'" [name]="'Lista'"></app-breadcrumb>
<div class="invoice-document-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

      <mat-form-field class="invoice-list-filter">
        <mat-label>Numer</mat-label>
        <input matInput placeholder="Numer" name="contains$number" [(ngModel)]="initialFilters.contains$number">
      </mat-form-field>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="invoice-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>


      <mat-form-field class="invoice-list-filter">
        <mat-label>Kwota od</mat-label>
        <input matInput placeholder="Kwota od" name="gte$net" [(ngModel)]="initialFilters.gte$net">
      </mat-form-field>

      <mat-form-field class="invoice-list-filter">
        <mat-label>Kwota do</mat-label>
        <input matInput placeholder="Kwota do" name="lte$net" [(ngModel)]="initialFilters.lte$net">
      </mat-form-field>


      <app-dict
        [multiple]="false" label="Firma"
        class="invoice-list-filter"
        dictType="company"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>


      <app-datepicker
        class="invoice-list-filter"
        label="Data utworzenia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$issueDate" name="gte$issueDate"
      ></app-datepicker>

      <app-datepicker
        class="invoice-list-filter"
        label="Data utworzenia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$issueDate" name="lte$issueDate"
      ></app-datepicker>
    </form>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      *ngIf="(userPermissions | async).settlement.read_report"
      [disabled]="!(userPermissions | async).settlement.read_report"
      (click)="downloadReport()" mat-raised-button class="report-button">
      <mat-icon>download</mat-icon>
      <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary">
      <mat-icon>search</mat-icon>
      <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">
    <table mat-table [dataSource]="items" matSort (matSortChange)="sortChanged($event)">

      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="number"> Numer</th>
        <td mat-cell *matCellDef="let element">
          <div fxLayout="row" fxLayoutGap="5" fxLayoutAlign="start center">
            <a class="default-link" [routerLink]="['/noty/szczegoly', element?.uuid]">
              {{ element.number }}
            </a>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="party">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="party"> Partner/OFWCA</th>
        <td mat-cell *matCellDef="let element">
          <div class="statusChange-flex-container">

            <a class="default-link"
               [routerLink]="['/partnerzy/szczegoly', element?.partner?.uuid]">{{ element?.partner?.shortName }}</a>
            <span *ngIf="element?.partner?.fullName !== element?.sellerCompanyName"> ({{ element?.sellerCompanyName }}) </span>

          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef> Firma</th>
        <td mat-cell *matCellDef="let element">
          {{ element.company?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="issueDate">
        <th mat-header-cell *matHeaderCellDef>Data wystawienia noty</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.issueDate | date:'yyyy-MM-dd' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef>Numer dokumentu księgowego</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngFor="let deduction of element.deductions; let i = index;  let last = last">

            <a class="default-link" [routerLink]="['/faktury/szczegoly', deduction?.invoice?.uuid]">
              {{ deduction?.invoice?.number }}
              <ng-container *ngIf="!last">, </ng-container>
            </a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="net">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="net"> Kwota faktury</th>
        <td mat-cell *matCellDef="let element">
          {{ element.net | number:'1.2-2' }} zł
        </td>
      </ng-container>

      <ng-container matColumnDef="netNot">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="net"> Kwota noty</th>
        <td mat-cell *matCellDef="let element">
          {{ element.net | number:'1.2-2' }} zł
        </td>
      </ng-container>

      <ng-container matColumnDef="remainingAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="remainingAmount"> Pozostała kwota</th>
        <td mat-cell *matCellDef="let element">
          {{ element.remainingAmount | number:'1.2-2' }} zł
        </td>
      </ng-container>
      <ng-container matColumnDef="deductedAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="deductedAmount"> Odliczona kwota</th>
        <td mat-cell *matCellDef="let element">
          {{ element.deductedAmount | number:'1.2-2' }} zł
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="action"></th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="(userPermissions | async).settlement.admin_root">
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
